<template>
  <div
    class="checkbox-field"
    :class="{
      '-disabled': fieldConfig && fieldConfig.disabled,
      '-implicit': isImplicitConsent,
    }"
  >
    <GlobalUICheckbox
      :id="fieldConfig && fieldConfig.id"
      :checked="internalValue"
      :disabled="fieldConfig && fieldConfig.disabled"
      :required="computedRequired"
      :aria-invalid="isImplicitConsent ? 'false' : hasError ? 'true' : 'false'"
      :label="fieldConfig && fieldConfig.label"
      :hide-checkbox="isImplicitConsent"
      label-class="field-label"
      @change="onChange"
    />
    <label
      v-if="hasError && !isImplicitConsent"
      :for="fieldConfig && fieldConfig.id"
      class="field-error"
    >
      {{ errorMessage }}
    </label>
  </div>
</template>

<script>
import errorDisplay from "../mixins/errorDisplay.js";
import vModelHelpers from "../mixins/vModelHelpers.js";
import GlobalUICheckbox from "../../GlobalUI/GlobalUICheckbox/GlobalUICheckbox.vue";

export default {
  name: "CheckboxField",
  components: {
    GlobalUICheckbox,
  },
  mixins: [errorDisplay, vModelHelpers],
  props: {
    fieldConfig: {
      type: Object,
      default: () => ({
        id: "checkbox-field",
        name: "",
        type: "checkbox",
        label: "",
        required: false,
        width: "FULL",
        disabled: false,
      }),
    },
    value: {
      type: Boolean,
      default: null,
    },
    modelValue: {
      type: Boolean,
      default: undefined,
    },
  },
  data() {
    return {
      internalValue:
        this.modelValue !== undefined ? this.modelValue : this.value,
      emittedImplicit: false,
    };
  },
  computed: {
    isImplicitConsent() {
      const config = this.fieldConfig;
      return !!(config && config.implicitConsent);
    },
    computedRequired() {
      // Do not mark as required in DOM if we are implicit consenting
      if (this.isImplicitConsent) return false;
      return !!(this.fieldConfig && this.fieldConfig.required);
    },
  },
  watch: {
    value(newValue) {
      if (this.modelValue !== undefined) return;
      this.internalValue = !!newValue;
    },
    modelValue(newValue) {
      this.internalValue = !!newValue;
    },
    isImplicitConsent(newValue) {
      if (newValue && !this.internalValue) {
        this.internalValue = true;
        if (!this.emittedImplicit) {
          this.emitModel(true);
          this.emittedImplicit = true;
        }
      }
    },
  },
  mounted() {
    if (this.isImplicitConsent) {
      if (!this.internalValue) this.internalValue = true;
      if (!this.emittedImplicit) {
        this.emitModel(true);
        this.emittedImplicit = true;
      }
    }
  },
  methods: {
    onChange(checked) {
      this.internalValue = checked;
      this.emitModel(checked);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/abstracts/mixins";
@import "../styles/field-shared";

.checkbox-field.-implicit {
  display: block;
}

.checkbox-field.-hidden {
  display: none;
}

.field-input {
  margin: 0;
}

.field-error {
  grid-column: 2;
}

.checkbox-field.-implicit .field-error {
  grid-column: 1;
}

.checkbox-field.-implicit .field-label {
  display: block;
  white-space: normal;
}

.-disabled {
  opacity: 0.6;
}
</style>
